/* Component Dependencies */
var metaHtmlHeadTemplate = require('templates/metaHtmlHead.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');

PubSub.register(AriesComponent.extend({
  type: 'metaHtmlHead',
  template: {
    'metaHtmlHead': metaHtmlHeadTemplate
  }
}));
